/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createLN10 } from '../../factoriesAny.js';
export var LN10Dependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createLN10: createLN10
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesLN10.generated.js
// module id = 1436
// module chunks = 0